import {
  convertDotcmsResponseToRecord,
  convertDotcmsStringNonNullable,
} from '../../converters-from-dotcms';
import type { ResourceType } from './resource-type';
import { getResourceTypeFromDotcms } from './resource-type';
import type { IGqlHelper } from '../../gql-helper';
import type { IResourceWithThumbnailData } from './resource-with-thumbnail';
import { ResourceWithThumbnailGqlHelper } from './resource-with-thumbnail';
import { buildGqlFieldsQuery } from '../../gql-builders';
import { CategoryGqlHelper } from '../../dotcms-category';
import type {
  IResourceLibraryCategorizableResource,
  ResourceSectionCategory,
} from './resource-section-category';
import { getResourceSectionCategoryFromDotcms } from './resource-section-category';

export type IUrlResourceWithThumbnailData = IResourceWithThumbnailData &
IResourceLibraryCategorizableResource & {
  resourceType: ResourceType;
  urlToLinkTo?: string;
};

export const UrlResourceWithThumbnailGqlHelper: IGqlHelper<IUrlResourceWithThumbnailData> =
  {
    contentTypeName: 'UrlResourceWithThumbnail',
    gqlFieldsQuery: `
      ${ResourceWithThumbnailGqlHelper.gqlFieldsQuery}
      resourceType { ${buildGqlFieldsQuery(CategoryGqlHelper)} }
      resourcePageSectionCategory { ${buildGqlFieldsQuery(CategoryGqlHelper)}}
      urlToLinkTo
    `,
    processGqlData: (gqlResponse: unknown) => {
      const baseResourceWithThumbnail =
        ResourceWithThumbnailGqlHelper.processGqlData(gqlResponse);
      if (!gqlResponse || !baseResourceWithThumbnail) {
        return undefined;
      }

      const { resourceType, resourcePageSectionCategory, urlToLinkTo } =
        convertDotcmsResponseToRecord(gqlResponse);

      const calculatedSectionCategory: ResourceSectionCategory =
        getResourceSectionCategoryFromDotcms(resourcePageSectionCategory);

      return {
        ...baseResourceWithThumbnail,
        resourceType: getResourceTypeFromDotcms(resourceType),
        resourcePageSectionCategory: calculatedSectionCategory,
        urlToLinkTo: convertDotcmsStringNonNullable(urlToLinkTo),
      };
    },
  };
